import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import element1 from '../../assets/blog-shape1.png';
import element2 from '../../assets/blog-shape2.png';

import css from './FAQPage.module.css';

function SectionHero() {
  return (
    <div className={css.heroContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1>
            <FormattedMessage id="FAQPage.schemaTitle" />
          </h1>
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
